export default __webpack_public_path__ + "static/media/payments.911f50c8.svg";